import api from '@/api_alv'
import Vue from 'vue'
import i18n from '@/assets/i18n/i18n'

const DIR = 'publishing/tracking'

const state = {
// SETLISTS
    setlists: [],
    selectedSetlists: [],  
    selectedSetlistsAction: '',  

// PROLISTS
    prolists: [],
    selectedProlists: [],  
    selectedProlistsAction: '',
    selectedUploadYear: new Date().getFullYear(),

// MAPPING
    myMapping: [],
    selectedMyMapping: [],
    myMappingEmptyRow:{
        prolistsPhrase: "",
        myPhrase: "",
        art: "",
        editable: true,
        new: true
    }
}

const getters = {
// SETLISTS    
    getSetlists(state) { return state.setlists },
    getSelectedSetlists(state) { return state.selectedSetlists },
    getSelectedSetlistsAction(state) { return state.selectedSetlistsAction },    

// PROLISTS  
    getProlists(state) { return state.prolists },
    getSelectedProlists(state) { return state.selectedProlists },
    getSelectedProlistsAction(state) { return state.selectedProlistsAction },
    getSelectedUploadYear(state) { return state.selectedUploadYear },

// MAPPING    
    getMyMapping(state) { return state.myMapping },
    getSelectedMyMapping(state) { return state.selectedMyMapping },
    getMyMappingEmptyRow(state) { return state.myMappingEmptyRow },    
}

const mutations = {
// SETLISTS    
    setSetlists: (state, SetlistsFromDB) => { state.setlists = SetlistsFromDB },
    setSelectedSetlists: (state, selectedSetlists) => { state.selectedSetlists = selectedSetlists },
    setSelectedSetlistsAction: (state, selectedAction) => { state.selectedSetlistsAction = selectedAction },    

// PROLISTS     
    setProlists: (state, prolists) => { state.prolists = prolists },
    setSelectedProlists: (state, selectedProlists) => { state.selectedProlists = selectedProlists },
    setSelectedProlistsAction: (state, selectedAction) => { state.selectedProlistsAction = selectedAction },
    setSelectedUploadYear: (state, year) => { state.selectedUploadYear = year },

    // EDIT Prolists Statements
    setProlistsTempRow: (state, row) => {
        let index = state.prolists.findIndex(statement => statement.id == row.id)
        let oldValues = JSON.parse(JSON.stringify(row))
        state.prolists[index]["oldValues"] = oldValues
    },
    deleteProlistsTempRow: (state, row) => {
        let index = state.prolists.findIndex(statement => statement.id == row.id)
        delete state.prolists[index]["oldValues"]
    },
    replaceNewProlistsValuesWithOld: (state, row) => {
        let index = state.prolists.findIndex(statement => statement.id == row.id)
        let oldValues = JSON.parse(JSON.stringify(state.prolists[index]["oldValues"]))
        Vue.set(state.prolists, index, oldValues)
    },

// MAPPING        
    setMyMapping: (state, myMapping) => { state.myMapping = myMapping },
    setSelectedMyMapping: (state, selected) => { state.selectedMyMapping = selected },    
    
    // EDIT Mapping
    setMyMappingTempRow: (state, row) => {
        let index = state.myMapping.findIndex(myMapping => myMapping.id == row.id)
        let oldValues = JSON.parse(JSON.stringify(row))
        state.myMapping[index]["oldValues"] = oldValues
    },
    deleteMyMappingTempRow: (state, row) => {
        let index = state.myMapping.findIndex( myMapping => myMapping.id == row.id)
        delete state.myMapping[index]["oldValues"]
    },
    replaceNewMyMappingValuesWithOld: (state, row) => { // RENAME
        let index = state.myMapping.findIndex(myMapping => myMapping.id == row.id)
        let oldValues = JSON.parse(JSON.stringify(state.myMapping[index]["oldValues"]))
        oldValues.editable = false
        Vue.set(state.myMapping, index, oldValues)
    }
}

const actions = {
// SETLISTS
    async fetchSetlists({ commit }) {
        let response = await api.getListData(DIR + '/setlists')
        commit('setIsLoading', false)

        if(response === undefined || response.length === 0 || response.error === 1) {
            response = []             
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
        }          

        commit('setSetlists', response)
    },
// PROLISTS
    async fetchProlists({ commit }) {
        let response = await api.getListData(DIR + '/prolists')
        commit('setIsLoading', false)

        if(response === undefined || response.length === 0 || response.error === 1) {
            response = []
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
        }             
            
        response.forEach((element) => {
            element['editable'] = false
            element['yearError'] = false
        });    

        commit('setProlists', response)
    },

    async deleteProlists({ commit, getters }) {                    
            let index = getters.getProlists.findIndex(entry => entry.id === getters.getSelectedProlists[0])
            Vue.delete(getters.getProlists, index);
            if(getters.getProlists.length == 0) {
                commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            }

            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t("lang_PUBLISHING_TRACKING_PROLISTS_SNACKBAR_DELETION")
            })
            commit('setSelectedProlists', [])          
    },

    async saveProlists({ getters, dispatch, commit }) {
        let response = await api.saveDataTables(DIR + '/prolists', getters.getProlists)

        if(response === undefined || response.length === 0 || response.error === 1) { 
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_PUBLISHING_TRACKING_PROLISTS_SNACKBAR_SAVE_FAILED')
            })            
        } else {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_PUBLISHING_TRACKING_PROLISTS_SNACKBAR_SAVE_SUCCESSFULLY')
            })
            dispatch("fetchProlists")
        }

        
    },

// MAPPING
    async fetchMyMapping({ commit }) {
        let response = await api.getListData(DIR + '/mapping')
        commit('setIsLoading', false)

        if(response === undefined || response.length === 0 || response.error === 1) {
            response = [] 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
        }  
        
        response.forEach((element) => {
            element['editable'] = false
        });
                
        commit('setMyMapping', response)
    },
    async saveMyMappingRow({ commit, dispatch }, row){
        let response

        if(row.new) response = await api.saveDataTableRow('publishing/tracking/mapping', 'addMapping', row)
        else response = await api.saveDataTableRow('publishing/tracking/mapping', 'updateMapping', row, row.id)

        if(response === undefined || response.length === 0 || response.error === 1) { 
            response = []
            commit('setSnackbar', { 
                type: 'error', 
                msg: 'Could not save mapping.', // lang const
            })
        } else {
            commit('setSnackbar', { 
                type: 'success', 
                msg: 'Mapping saved.' // lang const
            })
            // refresh data
            row.editable = false
            dispatch('fetchMyMapping')
        }        
    },
    addNewRowMyMapping({ commit, getters }){
        let arr = getters.getMyMapping
        let newRow = JSON.parse(JSON.stringify(getters.getMyMappingEmptyRow))
        newRow.id = -(1000 + Math.floor(Math.random() * 123));
        arr.push(newRow)
        commit('setMyMapping', arr);
    },
    async deleteMyMapping({ getters, commit }, alvId) { 
        // TODO!          
        // const response = await api.deleteEntries('publishing/tracking/mapping', alvId)

        if(response.error === -1) {
            // TODO SNACKBAR SUCCESS
            let id = getters.getSelectedMyMapping[0]
            let index = getters.getMyMapping.findIndex(myMapping => {
                return myMapping.id == id
            })
            Vue.delete(state.myMapping, index)  
        } else {
            // TODO SNACKBAR ERROR
        }  
        
        commit('setSelectedMyMapping', [])
    }    
}

export default {
    state, getters, actions, mutations
}